

module.exports = function($) {

    return {
        init: init
    };

    function init() {
        initFulfilmentDatePicker();
        initFieldPersistence();
    }

    // Left on the default mm/dd/yy: date_create() server-side reads slashes as
    // US m/d/Y, so a hand-typed Australian date stores a value it can't parse.
    function initFulfilmentDatePicker() {
        $('#order_comments_gift_fulfilment').datepicker({
            minDate: 0,
            maxDate: 90,
            onClose: function(inputValue, datepicker) {
                if (inputValue !== '') {
                    localStorage.setItem(datepicker.id, inputValue);
                }
            },
        });
    }

    function initFieldPersistence() {
        if (!$('body').hasClass('woocommerce-checkout')) {
            return;
        }

        var fields = $('input.input-text, textarea.input-text');

        fields.each(function() {
            var storedValue = localStorage.getItem($(this).attr('id'));

            // A miss returns null, which would blank a prefilled field.
            if (storedValue !== null) {
                $(this).val(storedValue);
            }
        });

        fields.on('focusout', function() {
            localStorage.setItem($(this).attr('id'), this.value);
        });
    }
};
